import React from 'react';
import { useStore } from '../stores';
import { observer } from 'mobx-react-lite';

import { Layers } from '../stores/layers';
import PreviewImage from '../components/Map/PreviewImage';

import { higestRankedCategory } from '../helpers/poiHelper';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';

import {
  Header,
  Close,
  Options,
  Tags,
  ContactData,
  Description,
  Copyright,
} from '../components/Information';

export const Information = observer(({ showTags }) => {
  const { poi, layers } = useStore();

  const hideAction = (event) => {
    event.stopPropagation();
    if (event.target === event.currentTarget) {
      poi.setInactive();
      layers.closeLayer();
    }
  };

  if (layers.activeLayer !== Layers.info) return null;

  return poi.active ? (
    <div
      onClick={hideAction}
      className="w-full h-screen pt-[calc(100vH_-_403px)] pb-[150px] overflow-auto absolute top-0 right-0 z-20 lg:w-[400px] shadow-lg lg:bg-white lg:py-0 lg:h-auto lg:top-5 lg:right-5 lg:bottom-5 lg:rounded-xl lg:shadow-xl"
    >
      <div
        onClick={(event) => (event.bubbles = false)}
        className="bg-white w-full p-6 relative shadow-[0_0_14px_0_rgba(0,0,0,0.3)] rounded-tr-[30px] lg:rounded-none lg:shadow-none"
      >
        <Close action={hideAction} />

        {poi.active?.images?.length ? (
          <>
            <Swiper
              className="mb-6 rounded-md overflow-hidden"
              modules={[Pagination, Autoplay]}
              pagination={{
                dynamicBullets: true,
                clickable: true,
              }}
              autoplay={{
                delay: 5000,
              }}
            >
              {poi.active?.images?.map((image, index) => (
                <SwiperSlide key={index}>
                  <div className="relative pb-[56.25%]">
                    <img
                      className="w-full h-full object-cover absolute top-0 left-0 rounded-md"
                      src={image?.url}
                      alt=""
                      onError={(event) => {
                        const newPoi = JSON.parse(JSON.stringify(poi.active));
                        newPoi.images.splice(index, 1);
                        poi.setActive(newPoi);
                      }}
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
            <Header poi={poi} />
          </>
        ) : (
          <div className="flex">
            <PreviewImage
              image={poi.active?.previewImageUrl}
              category={higestRankedCategory(poi.active)}
            />
            <Header className="pl-4" poi={poi} />
          </div>
        )}

        <Options />

        {/* //in config an ausschaltbar */}
        {showTags && <Tags />}

        <ContactData />

        <Description />

        <Copyright />
      </div>
    </div>
  ) : null;
});
